// Modelo Anamnesis BDD
export default class PatientAnamnesis {
    id=""
    date=""
    value=""
    patientRouteSheet=""
}



// WEBPACK FOOTER //
// ./src/model/PatientAnamnesis.js